/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_GenericInputs */

const en_auth_error_generic = /** @type {(inputs: Auth_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong on the way back from your provider. Nothing was charged and no account was changed.`)
};

const es_auth_error_generic = /** @type {(inputs: Auth_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal al volver de tu proveedor. No se realizó ningún cobro ni se modificó ninguna cuenta.`)
};

/**
* | output |
* | --- |
* | "Something went wrong on the way back from your provider. Nothing was charged and no account was changed." |
*
* @param {Auth_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_error_generic = /** @type {((inputs?: Auth_Error_GenericInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_GenericInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_error_generic(inputs)
	return en_auth_error_generic(inputs)
});